import { PropsWithChildren, useReducer } from 'react';
import { SettingsContext } from './context';
import { reducer } from './utils';
import { initialState } from './initialState';
import { useInstallPwaPrompt } from './hooks/useInstallPwaPrompt';
import { useLiveChat } from 'src/modules/livechat/useLiveChat';

/** @todo добавить сюда состояния отображения куки баннера и блока предлагающего установку PWA
 * и переписать DrawerContext на одно состояние
 */
export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const [settings, dispatch] = useReducer(reducer, initialState);

  const pwaPromptTools = useInstallPwaPrompt();
  const liveChatTools = useLiveChat();

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        setSettings: dispatch,
        pwa: pwaPromptTools,
        chat: liveChatTools
      }}>
      {children}
    </SettingsContext.Provider>
  );
};
